import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import firebase from 'firebase/app';
import Raven from 'raven-js';

import reduxStore from './reduxStore.js';
import Routes from './routes';
import { firebaseConfig } from '../config-common.js';

Raven.config('https://3fbd789e281e40f4bb05c2374e87b9e2@sentry.io/256844').install();

firebase.initializeApp(firebaseConfig);

// supress logs in production
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  // console.warn = () => {};
  // eslint-disable-next-line no-console
  console.error = () => {};
}

const App = () => {
  return (
    <Provider store={reduxStore}>
      <Routes />
    </Provider>
  );
};

render(<App />, document.getElementById('root'));
